import { axiosApiInstance, axiosPrinterInstance } from "../axios";

export interface ServerRenderedLabel {
  print_job_id: string;
  zpl: string;
  copies?: number;
}

async function acknowledge(
  jobId: string,
  status: "sent" | "failed",
  failureMessage?: string,
) {
  try {
    await axiosApiInstance.patch(
      `label-print-jobs/${jobId}`,
      { status, failure_message: failureMessage ?? null },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      },
    );
  } catch {
    // Printing must not be reported as failed merely because audit acknowledgement failed.
  }
}

export async function printServerRenderedLabel(label: ServerRenderedLabel) {
  if (!label?.print_job_id || !label?.zpl) {
    return {
      success: false,
      data: { message: "The server did not return a printable ZPL label." },
    };
  }

  try {
    const response = await axiosPrinterInstance.post(
      "v1/print",
      { job_id: label.print_job_id, zpl: label.zpl, copies: label.copies ?? 1 },
      { headers: { "content-type": "application/json" }, timeout: 15000 },
    );
    await acknowledge(label.print_job_id, "sent");
    return { success: true, data: response.data };
  } catch (error: any) {
    const message =
      error?.response?.data?.error ??
      error?.message ??
      "The local print agent is unavailable.";
    await acknowledge(label.print_job_id, "failed", message);
    return {
      success: false,
      data: { message },
      errorStatus: error?.response?.status,
    };
  }
}
